import { useEffect } from "react";
import IconSayAboutUs from "./icon-sayaboutus";

export default function NotFound() {
	useEffect(() => {
		document.title = "This page is not available - Say About Us";
	}, []);

	return (
		<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 px-4">
			<div className="max-w-md w-full text-center">
				<div className="mb-8">
					<h1 className="text-6xl font-bold text-gray-300 dark:text-gray-700 mb-4">
						404
					</h1>
				</div>

				<h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-4">
					This page is not available
				</h2>

				<p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
					We couldn't find the page you're looking for. It might be
					temporarily disabled, or the link might be incorrect.
					<br />
				</p>

				<p className="text-gray-600 dark:text-gray-400 mb-8 leading-relaxed">
					Please try again later or check with the person who shared
					this link with you.
				</p>

				<div className="mt-12 p-6 text-gray-900 dark:text-gray-100 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
					<IconSayAboutUs className="w-12 h-12 mx-auto mb-4" />
					<h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
						Collect testimonials with SayAbout.us
					</h3>
					<p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
						Create your own feedback forms.
					</p>
					<a
						href="https://sayabout.us"
						target="_blank"
						rel="noopener noreferrer"
						className="inline-block px-6 py-2 bg-[#222] dark:bg-white text-white dark:text-gray-900 font-medium rounded-lg hover:bg-[#333] dark:hover:bg-gray-100 transition-all duration-200"
					>
						Get started
					</a>
				</div>
			</div>
		</div>
	);
}
